import React from "react";
import { Button, Modal, Radio } from "antd";
import Utils from "@/utils";
import { useTranslation } from "react-i18next";

const ConvertModalRender = ({ files, visible, linkToEditorWorkType, onCancel, handleContinueFile, handleLinkToOnlineEditor }) => {
  const { t } = useTranslation(["convert", "common"]);

  const getWork = () => {
    switch (linkToEditorWorkType) {
      case "cut":
        return "Cut";
      case "speed":
        return "Speed";
      case "crop_rotate":
        return "Crop & Rotate";
      case "resize":
        return "Resize";
      case "mute":
        return "Extract";
      case "addMusic":
        return "Add Music";
      case "subtitle":
        return "Subtitles";
      case "merge":
        return "Merge";
      case "removeWatermark":
        return "Watermark Remover";
      case "addWatermark":
        return "Add Watermark";
      default:
        return "";
    }
  };

  return (
    <Modal
      centered
      visible={visible}
      onCancel={onCancel}
      footer={null}
      width="520px"
      getContainer={document.querySelector(".Home")}
      className="convertModal"
    >
      <p>{t("Please select a file to use", { work: t(getWork()) })}:</p>
      <Radio.Group onChange={handleContinueFile}>
        {files
          .filter(item => item.fileType === "video" && item.convertFileType === "video" && item.status === "success")
          .map(item => (
            <Radio value={item.guid} key={item.guid}>
              <div className="radio-item">
                <span>{Utils.omissionString(item.newName, 5, 5)}</span>
                <span>{(item.newSize / 1024 / 1024).toFixed(2)}MB</span>
              </div>
            </Radio>
          ))}
      </Radio.Group>
      <div className="btn-group">
        <Button type="primary" ghost size="large" onClick={onCancel}>
          {t("common:Cancel")}
        </Button>
        <Button type="primary" size="large" onClick={handleLinkToOnlineEditor}>
          {t("common:Confirm")}
        </Button>
      </div>
    </Modal>
  );
};

export default ConvertModalRender;
